export const { default: AppConfigProvider } = await import('./Providers/AppConfigProvider')
export const { default: ScreenStyleConfigProvider } = await import('./Providers/ScreenStyleConfigProvider')
export const { default: DefLinksConfigProvider } = await import('./Providers/DefLinksConfigProvider')
export const { default: DefLinksConditionsProvider } = await import('./Providers/DefLinksConditionsProvider')
export const { default: MonetizationConfigProvider } = await import('./Providers/MonetizationConfigProvider')
